export default __webpack_public_path__ + "static/Annual_Multimedia_logo_white-72b1b696869014421a2ed416b3cf8d1f.svg";